import React from 'react';

export const Highlight = ({ children, tone = 'coral' }) => {
  const gradient =
    tone === 'coral'
      ? 'linear-gradient(120deg, rgba(235,160,155,0.55) 0%, rgba(245,185,165,0.45) 100%)'
      : 'linear-gradient(120deg, rgba(245,185,165,0.55) 0%, rgba(245,215,170,0.45) 100%)';
  return (
    <span
      style={{
        background: gradient,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 38%',
        backgroundPosition: '0 85%',
        padding: '0 1px',
        WebkitBoxDecorationBreak: 'clone',
        boxDecorationBreak: 'clone',
      }}
    >
      {children}
    </span>
  );
};
